import React from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import dashboardImage from '../../../../assets/img/dashboard-image.webp';

const WhyTrustUsSection = ({ openModal }) => {
    const { t } = useTranslation();
    const list = t('pages.dmarcChecker.dashboard.body2', { returnObjects: true });

    return (
        <section className="py-5 bg-light">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} lg={6} className="mb-4 mb-lg-0">
                        <Image src={dashboardImage} alt={t('pages.dmarcChecker.dashboard.imageAlt')} fluid className="rounded" />
                    </Col>
                    <Col xs={12} lg={6}>
                        <small className="text-uppercase text-muted mb-2 d-block">
                            {t('pages.dmarcChecker.dashboard.subTitle')}
                        </small>
                        <h3 className="fw-bold">
                            {t('pages.dmarcChecker.dashboard.title')}
                        </h3>
                        <p className="mb-4">
                            {t('pages.dmarcChecker.dashboard.body')}
                        </p>
                        <hr className="my-4" />
                        <h3 className="fw-bold">
                            {t('pages.dmarcChecker.dashboard.title2')}
                        </h3>
                        <ul className="list-unstyled mt-4">
                            {list.map((item, index) => (
                                <li key={index} className="mb-3">
                                    <p className="fw-bold mb-1">{item.title}</p>
                                    <p className="mb-0">{item.body}</p>
                                </li>
                            ))}
                        </ul>
                        <div className="d-grid mt-4">
                            <Button variant="primary" size="lg" onClick={openModal}>
                                {t('pages.dmarcChecker.painPoint.bookACall')}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default WhyTrustUsSection;
